import React, { useEffect } from 'react';
import ErrorBoundary from '../../components/ErrorBoundary';

/**
 * Component that intentionally throws an error to demonstrate the ErrorBoundary's fallback UI
 */
const ErrorThrower: React.FC = () => {
  useEffect(() => {
    throw new Error('This is an intentional error to demonstrate the ErrorBoundary');
  }, []);

  return <div>This text will not be shown due to the error being thrown</div>;
};

/**
 * Wrapper component that places the ErrorThrower inside the ErrorBoundary
 * This allows viewing the error page without affecting the rest of the application
 */
const TemporaryErrorTriggerScreen: React.FC = () => {
  return (
    <ErrorBoundary>
      <ErrorThrower />
    </ErrorBoundary>
  );
};

export default TemporaryErrorTriggerScreen; 